import { createAction, props } from '@ngrx/store';
import { AnalysisDocument, AnalysisStateData } from 'src/app/shared/interface/analysis';
import { analysisError } from 'src/app/shared/interface/error.interface';

export const loadAnalysis = createAction(
  '[Analysis] Load Analysis',
  props<{ id: string }>()
);

export const resetState = createAction('[Analysis] Reset State Analysis');

export const loadAnalysisFail = createAction(
  '[Analysis] Load Analysis Fail',
  props<{ error: analysisError }>()
);
export const loadAnalysisSuccess = createAction(
  '[Analysis] Load Analysis Success',
  props<{ payload: AnalysisStateData }>()
);

export const reloadAnalysis = createAction('[Analysis] Reload Analysis');
export const reloadAnalysisFail = createAction(
  '[Analysis] Reload Analysis Fail'
);
export const reloadAnalysisSuccess = createAction(
  '[Analysis] Reload Analysis Success',
  props<{ payload: AnalysisStateData }>()
);

export const selectDocument = createAction(
  '[Analysis] Set Current Document',
  props<{ module: string; payload: any, document?: any }>()
);
export const selectDocumentFail = createAction(
  '[Analysis] Set Current Document Fail',
  props<{ error: any }>()
);
export const selectDocumentSuccess = createAction(
  '[Analysis] Set Current Document Success',
  props<{ document: string }>()
);

// ACTIONS DOCUMENTS
export const approveDocument = createAction(
  '[AnalysisDocuments] Approve Document',
  props<{ key: string }>()
);
export const updateDocuments = createAction(
  '[AnalysisDocuments] Update Documents',
  props<{ documents: any }>()
);
export const reproveDocument = createAction(
  '[AnalysisDocuments] Reprove Document',
  props<{ key: string }>()
);

export const updateField = createAction(
  '[AnalysisFields] Update Fields',
  props<{
    module: string;
    documentKey: string;
    payload: any;
    document: any;
    value? : string | null;
  }>()
);

export const updateFieldSystem = createAction(
  '[AnalysisFields] Update Fields System',
  props<{
    module: string;
    documentKey: string;
    payload: any;
    document: any;
    value? : string | null;
  }>()
);

export const updateFieldSuccess = createAction(
  '[AnalysisFields] Update Fields Success',
  props<{
    documentKey: string;
    payload: any;
  }>()
);
export const updateFieldFail = createAction(
  '[AnalysisFields] Update Fields Fail',
  props<{
    error: any,
    documentKey: string;
    payload: any;
  }>()
);

// ACTIONS VOUCHERS
export const setCurrentVoucher = createAction(
  '[AnalysisVouchers] Set Current Voucher',
  props<{
    module: string;
    payload: any;
    documentKey: string;
    document: AnalysisDocument;
  }>()
);
export const setCurrentVoucherFail = createAction(
  '[AnalysisVouchers] Set Current Voucher Fail',
  props<{ error: any }>()
);
export const setCurrentVoucherSuccess = createAction(
  '[AnalysisVouchers] Set Current Voucher Success',
  props<{ documentKey: string; document: AnalysisDocument; voucherKey: string }>()
);

export const reproveVoucher = createAction(
  '[AnalysisVouchers] Reprove Vouchers',
  props<{ module: string; payload: any; document: AnalysisDocument }>()
);
export const reproveVoucherFail = createAction(
  '[AnalysisVouchers] Reprove Vouchers Fail',
  props<{ error: any }>()
);
export const reproveVoucherSuccess = createAction(
  '[AnalysisVouchers] Reprove Vouchers Success',
  props<{ documentKey: string; document: AnalysisDocument , target: string, reasons: string[]}>()
);

export const approveVoucher = createAction(
  '[AnalysisVouchers] Approve Vouchers',
  props<{ module: string; voucher: any; document: AnalysisDocument }>()
);
export const approveVoucherFail = createAction(
  '[AnalysisVouchers] Approve Vouchers Fail',
  props<{ error: any }>()
);
export const approveVoucherSuccess = createAction(
  '[AnalysisVouchers] Approve Vouchers Success',
  props<{ key: string; document: AnalysisDocument }>()
);

// ACTIONS TIMEOUT
export const timeoutAnalysis = createAction(
  '[Analysis] Analysis Timeout',
  props<{ module: string; payload: any }>()
);
export const timeoutAnalysisFail = createAction(
  '[Analysis] Analysis Timeout Fail',
  props<{ error: any }>()
);
export const timeoutAnalysisSuccess = createAction(
  '[Analysis] Analysis Timeout Success'
);

export const approveEsocial = createAction(
  '[AnalysisEsocial] Approve Esocial',
  props<{ module: string; document: any; status: string, mensage: string }>()
);
export const approveEsocialSuccess = createAction(
  '[AnalysisEsocial] Approve Esocial Success',
  props<{ document: any, status: string, mensage: string }>()
);
export const approveEsocialFail = createAction(
  '[AnalysisEsocial] Approve Esocial Fail',
  props<{ error: string }>()
);

export const tracking = createAction(
  '[Analysis] Tracking Event',
  props<{
    title: string;
    action: string;
    document: string;
    field: string;
    bankTrackingProperties? : { bankCode: string, bankDigit: string}
  }>()
);

export const trackingEsocial = createAction(
  '[Analysis] Tracking Esocial Event',
  props<{
    title: string;
    properties: { [key: string]: any};
  }>()
);

export const callEsocial = createAction('[Analysis] Call Esocial');
export const resetEsocal = createAction('[Analysis] Reset Esocial');